export function debounce<T extends (...args: any[]) => void>(fn: T, wait: number): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return function (...args: Parameters<T>): void {
    if (timer) {
      clearTimeout(timer); // clear any pre-existing timer
    }
    timer = setTimeout(() => {
      fn(...args); // call the function if time expires
    }, wait);
  };
}
